export const GET_LANGUAGES_REQUEST = 'GET_LANGUAGES_REQUEST';
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
export const GET_LANGUAGES_ERROR = 'GET_LANGUAGES_ERRROR';

export const SWITCH_LANGUAGE_REQUEST = 'SWITCH_LANGUAGE_REQUEST';
export const SWITCH_LANGUAGE_SUCCESS = 'SWITCH_LANGUAGE_SUCCESS';
export const SWITCH_LANGUAGE_ERROR= 'SWITCH_LANGUAGE_ERROR';

